import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the import popups still read from the workspace: the open flags and wizard state the Clients toolbar resets when it opens them, the directory and users lists and loaders refreshed after a save, and the Add client master data.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmClientsImportModalHost = Pick<
  PmWorkspaceComponent,
  | 'clientsAddCountries'
  | 'clientsBookMeetingPickerRows'
  | 'clientsDirectoryPageNumber'
  | 'clientsFilterTypeOptions'
  | 'clientsImportFileName'
  | 'clientsImportFilterTab'
  | 'clientsImportModalOpen'
  | 'clientsImportPreviewRows'
  | 'clientsImportSaveError'
  | 'clientsImportSavePending'
  | 'clientsImportSaveResult'
  | 'clientsImportStep'
  | 'clientsSortedRows'
  | 'clientsUsersImportColumnsDetected'
  | 'clientsUsersImportDraftRows'
  | 'clientsUsersImportEmailsLoaded'
  | 'clientsUsersImportErrors'
  | 'clientsUsersImportFileName'
  | 'clientsUsersImportModalOpen'
  | 'clientsUsersImportPracticeEmails'
  | 'clientsUsersImportPreviewRows'
  | 'clientsUsersImportSavePending'
  | 'clientsUsersImportSelectedIds'
  | 'clientsUsersImportStaged'
  | 'clientsUsersImportStep'
  | 'clientsUsersPageNumber'
  | 'collectExistingClientReferenceIds'
  | 'effectiveDirectoryActingUserIdForContacts'
  | 'effectiveDirectoryParentUserId'
  | 'effectiveDirectoryUserIdForClientsList'
  | 'ensureClientUsersFirmTotalCount'
  | 'ensureClientsUsersImportPracticeEmails'
  | 'invalidateDirectoryClientsCache'
  | 'lastClientsUsersFirmCountKey'
  | 'loadClientsAddAllClientRefs'
  | 'loadDirectoryClientUsers'
  | 'loadDirectoryClientsPage'
  | 'notifyError'
  | 'refreshBookMeetingPickerIfNeeded'
  | 'resetClientsImportWizardState'
  | 'resetClientsUsersImportWizardState'
  | 'stopPropAllowSpaceInFields'
>;

export const PM_CLIENTS_IMPORT_MODAL_HOST = new InjectionToken<PmClientsImportModalHost>('PmClientsImportModalHost');
